// Garde le tunnel SEA en navigation client : un lead déjà inscrit (ou avec téléphone) ne revoit pas
// les étapes passées. Les chargements directs (SSR) sont gérés en amont par le middleware Nitro
// (server/middleware/tunnel-landing-page-redirect.ts) — même décision, autre exécution.

import { getMsalActiveAccountEmail, hydrateUserStoreFromMsalIfNeeded } from '~/utils/msalUtils'
import { TempUserSession } from '~/utils/tempUserSession'

const PHONE_STEP: number = 5

export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.client || !to.path.includes('/landing-page/')) return

  await hydrateUserStoreFromMsalIfNeeded()
  const fallbackEmail: string | null = await getMsalActiveAccountEmail()
  await TempUserSession.syncProfileFromMe(fallbackEmail)

  const localePath = useLocalePath()

  const userStore = useUserStore()
  if (!userStore.isLoggedIn) return

  if (userStore.hasPhone) {
    return navigateTo(localePath('/discuter'), { replace: true })
  }

  const requestedStep: number = Number(to.query.step) || 1
  if (requestedStep < PHONE_STEP) {
    return navigateTo(
      { path: to.path, query: { ...to.query, step: String(PHONE_STEP) } },
      { replace: true },
    )
  }
})
